import Boundary from "./boundary";

class Branch extends Boundary {
    branchId;

    constructor(props) {
        super();
        this.branchId = props.id;
        this.volumes = [];
        this.modelName = undefined;
        this.modelId = undefined;
        this._populateBranchVolumes();
        this._addHandlers();
        this.updateBoundingBox();
    }

    _addHandlers() {
        addHandlerForOperation(this.modelId, [this.modelId], this.updateBoundingBox.bind(this), this.branchId + "boundary",
            HANDLER_TYPE_ENUM.BOUNDARY, HANDLER_TYPE_ENUM.BOUNDARY);
    }

    _populateBranchVolumes() {
        const branchNode = MeshHierarchyViewFeatureData.getDataFromBranchID(this.branchId);
        if (branchNode) {
            this.volumes = branchNode.getLeaves();
            this.modelId = getModelIdFromBranchId(this.volumes[0]);
            this.modelName = modelManager.getModelNamebyModelId(this.modelId);
        }
    }

    updateBoundingBox() {
        const branchBoundingBox = getCurrentBoundingBoxOfVolumesInWorld(this.volumes);
        if (branchBoundingBox) {
            this.bBox.copy(branchBoundingBox);
        }
    }
}

export default Branch;
